import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=b94ff95e&scoped=true&"
import script from "./StaffManage.vue?vue&type=script&lang=js&"
export * from "./StaffManage.vue?vue&type=script&lang=js&"
import style0 from "./StaffManage.vue?vue&type=style&index=0&id=b94ff95e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94ff95e",
  null
  
)

export default component.exports